import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import Department from "../types/Department";

type Output = Department;

export default function useDepartmentGet (
    departmentId: string | number,
    options?: CacheQueryOpts<Output>
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    
    return useCacheQuery<Output>(
        ["department", departmentId],
        () => {
            return client.get<Output>(`departments/${departmentId}`);
        },
        options
    );
}

